import { useEffect, useRef } from "react";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Box,
  Tooltip,
} from "@mui/material";

export const ExcelTable = ({ excelData, maxLength = 60 }) => {
  // Scroll to the table when button is clicked
  const tableRef = useRef(null);
  useEffect(() => {
    tableRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  if (!Array.isArray(excelData) || excelData.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: "text.secondary" }} align="center">
        We couldn’t display the data from your Excel test file.
      </Typography>
    );
  }

  // Get column headers dynamically from keys of the first row
  const headers = Object.keys(excelData[0]);

  // Calculate if columns need wider width based on content
  const getColumnWidth = (header) => {
    const hasLongContent = excelData.some((row) => {
      const value = String(row[header] ?? "N/A");
      return value.length > maxLength;
    });
    return hasLongContent ? 300 : 200;
  };

  return (
    <Box ref={tableRef}>
      <Typography variant="subtitle3">Tested File Preview</Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table stickyHeader aria-label="excel test table" size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell key={index}> {header} </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {excelData.map((row, rowIndex) => (
              <TableRow key={rowIndex} hover>
                {headers.map((header, colIndex) => {
                  const cellValue = row[header] ?? "N/A";
                  const displayValue = String(cellValue);
                  const isTruncated = displayValue.length > maxLength;
                  return (
                    <TableCell
                      key={colIndex}
                      sx={{
                        minWidth: getColumnWidth(header),
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {isTruncated ? (
                        <Tooltip title={displayValue} arrow>
                          <span
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "inline-block",
                              maxWidth: "100%",
                            }}
                          >
                            {displayValue.slice(0, maxLength) + "..."}
                          </span>
                        </Tooltip>
                      ) : (
                        <span>{displayValue}</span>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
